import { createWebHistory, createRouter } from 'vue-router'
import { cloneDeep } from 'lodash'

import { ROUTE_NAME } from '@/const'
import { DISABLE_ROUTES } from '@/plugins/hubspot/utils/const'

import routes from '@/router/routes'

import { useHubspot } from '@/plugins/hubspot'

import { useMainStore } from '@/store/main'
import { useRepositoriesStore } from '@/store/repositories'

const hubspot = useHubspot()

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0, behavior: 'smooth' }
  },
})

router.beforeEach(async (to, from) => {
  if (
    // if not opening form
    !to.name?.toString().includes('-item') &&
    // and if leave form but not to the parent route
    to.name && !from.name?.toString().includes(to.name.toString())
  ) {
    try {
      await useMainStore().checkBlockers()
    } catch {
      return false
    }
  }
  if (to.path === '/linked-accounts' && !useRepositoriesStore().isPartiallyShared) {
    return { path: '/connectors', query: to.query }
  }
  if (!from.name && to.name === ROUTE_NAME.DASHBOARDS && to.query.code) {
    const route = cloneDeep(to)
    delete route.query.code
    delete route.query.state
    return route
  }
  if (to.path === '/connectors' && useRepositoriesStore().isPartiallyShared) {
    return { name: ROUTE_NAME.PERMISSION_DENIED }
  }
  return undefined
})

router.afterEach(to => {
  if (DISABLE_ROUTES.includes(to.name as string)) {
    hubspot?.destroy()
  } else {
    hubspot?.refresh()
  }

  useMainStore().setAppInitialized(true)
})

export default router
